import React from "react";

// スタイルインポート
import "../../pages/css/works.scss";
import "../../responsive/WorksResponsive.scss";
import "../../common.scss";

// 縦線
import line from "../../img/services/Rectangle.svg";

// 制作事例01
import work01 from "../../img/works/graphic_design.png";
import work02 from "../../img/works/graphic_design2.png";
import work03 from "../../img/works/graphic_design3.png";
import work04 from "../../img/works/graphic_design4.png";

import url01 from "../../img/works/PDF/pdf_design01.pdf";
import url02 from "../../img/works/PDF/pdf_design02.pdf";
import url03 from "../../img/works/PDF/pdf_design03.pdf";
import url04 from "../../img/works/PDF/pdf_design04.pdf";

function GraphicDesign() {
  return (
    <>
      <section className="wrk-main-sec">
        <div className="wrk-img">
          <img src={work01} alt="" />
        </div>
        <div className="wrk-ttl">サンプルデザイン０１</div>
        <div className="wrk-desc"></div>
        <table border="1" class="wrk-table">
          <tr>
            <th>公開</th>
            <th>2022/06/30 ～</th>
          </tr>
          <tr>
            <td>種類</td>
            <td>チラシ</td>
          </tr>
          <tr>
            <td>PDF</td>
            <td>
              <a href={url01} target="_blank">
                PDFはこちら
              </a>
            </td>
          </tr>
          <tr>
            <td>担当</td>
            <td>
              <dl>
                <dt>企画・ワイヤ設計</dt>
                <dd>SmartGenz アリア</dd>
                <dt>デザイン</dt>
                <dd>SmartGenz アリア</dd>
              </dl>
            </td>
          </tr>
        </table>
      </section>
      <section className="wrk-main-sec">
        <div className="wrk-img">
          <img src={work02} alt="" />
        </div>
        <div className="wrk-ttl">サンプルデザイン０２</div>
        <div className="wrk-desc"></div>
        <table border="1" class="wrk-table">
          <tr>
            <th>公開</th>
            <th>2022/06/30 ～</th>
          </tr>
          <tr>
            <td>種類</td>
            <td>チラシ</td>
          </tr>
          <tr>
            <td>PDF</td>
            <td>
              <a href={url04} target="_blank">
                PDFはこちら
              </a>
            </td>
          </tr>
          <tr>
            <td>担当</td>
            <td>
              <dl>
                <dt>企画・ワイヤ設計</dt>
                <dd>SmartGenz アリア</dd>
                <dt>デザイン</dt>
                <dd>SmartGenz アリア</dd>
              </dl>
            </td>
          </tr>
        </table>
      </section>
      <section className="wrk-main-sec">
        <div className="wrk-img">
          <img src={work03} alt="" />
        </div>
        <div className="wrk-ttl">サンプルデザイン０３</div>
        <div className="wrk-desc"></div>
        <table border="1" class="wrk-table">
          <tr>
            <th>公開</th>
            <th>2022/06/30 ～</th>
          </tr>
          <tr>
            <td>種類</td>
            <td>チラシ</td>
          </tr>
          <tr>
            <td>PDF</td>
            <td>
              <a href={url03} target="_blank">
                PDFはこちら
              </a>
            </td>
          </tr>
          <tr>
            <td>担当</td>
            <td>
              <dl>
                <dt>企画・ワイヤ設計</dt>
                <dd>SmartGenz アリア</dd>
                <dt>デザイン</dt>
                <dd>SmartGenz アリア</dd>
              </dl>
            </td>
          </tr>
        </table>
      </section>
      <section className="wrk-main-sec">
        <div className="wrk-img">
          <img src={work04} alt="" />
        </div>
        <div className="wrk-ttl">サンプルデザイン０４</div>
        <div className="wrk-desc"></div>
        <table border="1" class="wrk-table">
          <tr>
            <th>公開</th>
            <th>2022/06/30 ～</th>
          </tr>
          <tr>
            <td>種類</td>
            <td>チラシ</td>
          </tr>
          <tr>
            <td>PDF</td>
            <td>
              <a href={url02} target="_blank">
                PDFはこちら
              </a>
            </td>
          </tr>
          <tr>
            <td>担当</td>
            <td>
              <dl>
                <dt>企画・ワイヤ設計</dt>
                <dd>SmartGenz アリア</dd>
                <dt>デザイン</dt>
                <dd>SmartGenz アリア</dd>
              </dl>
            </td>
          </tr>
        </table>
      </section>
    </>
  );
}
export default GraphicDesign;
